(function (ws) {
    'use strict';
    ws.views.rfqTableReseller = ws.views.simpleTable.extend({
        /**
         * Initialize override
         */
        initialize: function() {
            this.$table = $('#rfq-table-reseller');
            this.rowTemplate = $('#rfq-table-row-reseller');
            this.paginateUrl = globals.path.api.quoting.rfqTablePaginateUrl;
            this.searchUrl = globals.path.api.quoting.rfqTableSearchUrl;

            ws.views.simpleTable.prototype.initialize.call(this);
        }
    });
})(westcon);
